import styled from 'styled-components'
import { breakpoints } from '../../../MediasQueries'

export const BackgroundModal = styled.div`
  z-index: 99;
  position: fixed;
  top: 0;

  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);

  transition: opacity 0.3s ease;
  ${(props) => (props.show ? 'opacity : 1' : 'opacity:0')};
  .active {
    opacity: 1;
    transform: translateY(0);
  }
`

export const CloseContainer = styled.div`
  display: flex;
  justify-content: end;
  -webkit-justify-content: flex-end;
`

export const ButtonExit = styled.button`
  font-size: 25px;
`
export const Content = styled.div`
  height: 100%;
`
export const ContainerModal = styled.div`
opacity:0.3;
transform: translateY(-100vh);
transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);


display:flex;
flex-direction:column;
background: ${({ theme }) => theme.background};
border-radius:5px;
padding:20px;
width: ${(props) => props.width};
min-width: ${(props) => props.minWidth};
height:${(props) => props.height};
min-height:${(props) => props.minHeight};
overflow: auto;
-webkit-box-shadow:0 0 40px rgb(8 21 66 / 15%);
box-shadow: 0 0 40px rgb(8 21 66 / 15%);
@media(max-width:${breakpoints.sm}) {
  min-width:93vw;
  padding:13px;
}

}
`

export const TitleModal = styled.h2`
  text-transform: uppercase;
  font-size: 3vh;
  margin-bottom: 3vh;
  text-align: center;
`

export const ContentModal = styled.div`
  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
`
